<template>
  <div class="DropDown lxn-cursor-pointer">
    <div v-if="selectedIndex != -1" @click="openDropDownModal()" class="DropDown-main lxn-w100 lxn-border-round lxn-pos-rel" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass, disabledClass]">
      {{dropDownName}}
      <div class="DropDown-wrapper-icon lxn-w100 lxn-h100 lxn-pos-abs">
        <div class="DropDown-icon" :class="$store.getters.language.floatClassReverse">
          <ButtonIcon :size="40" bgColor="#ECECEC" :icon="dropDownIcon" iconColor="#53636C" :padding="8" />
        </div>
      </div>
    </div>
    <div v-show="showModal" class="DropDown-wrapper-modal lxn-pos-abs lxn-w100 lxn-border-round lxn-overflow-hidden">
      <div @click="closeModal();" class="DropDownModal-wrapper-header lxn-w100 lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
        {{dropDownContex.title}}
      </div>
      <div class="DropDownModal-wrapper-options lxn-w100">
        <div v-for="(option, index) in dropDownContex.data" :key="index" class="DropDownModal-option">
          <CustomButton v-if="dropDownContex.name !== undefined" @click="selectOption(index)" :buttonState="buttonState(index)" bgColor="#ECECEC" :iconLeft="option.icon" iconLeftColor="#B8B8B8" iconLeftBgColor="#ECECEC" textColor="#52626C" :iconLeftPadding="8" :useLanguageDirection="true">
            {{option.name}}
          </CustomButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonIcon from '@/components/ButtonIcon.vue'
import CustomButton from '@/components/CustomButton.vue'

export default {
  name: 'DropDown',
  components: {
    ButtonIcon,
    CustomButton,
  },
  props: {
    dropDownContex: Object,
    disabled: Boolean,
  },
  destroyed: function () {
  },
  data: function () {
    return {
      showModal: false,
      currentScrollTop: 0,
    }
  },
  mounted: function () {
  },
  computed: {
    dropDownName: function () {
      if(this.dropDownContex.data.length != 0){
        return this.dropDownContex.data[this.selectedIndex].name;
      }else{
        return this.dropDownContex.title;
      }
    },
    dropDownIcon: function () {
      if(this.dropDownContex.data.length != 0){
        return this.dropDownContex.data[this.selectedIndex].icon;
      }else{
        return "noIcon";
      }
    },
    selectedIndex: function () {
      return this.dropDownContex.selectedIndex;
    },
    disabledClass: function () {
      return this.disabled ? 'disabled' : '';
    },
  },
  methods: {
    closeModal: function () {
      this.showModal = false;
    },
    openDropDownModal: function () {
      if(!this.disabled){
        this.showModal = true;
        //add and remove of overflow hidden is for android devices bug
        if(document.documentElement.scrollTop){
          this.currentScrollTop = document.documentElement.scrollTop;
        }else if(document.body.scrollTop){
          this.currentScrollTop = document.body.scrollTop;
        }
        document.body.classList.add("lxn-overflow-hidden");
        document.documentElement.classList.add("lxn-overflow-hidden");
        document.documentElement.scrollTop = document.body.scrollTop = 0;
        document.body.classList.remove("lxn-overflow-hidden");
        document.documentElement.classList.remove("lxn-overflow-hidden");
      }
    },
    selectOption: function (index) {
      this.$emit('input', index);
      this.showModal = false;
      document.body.classList.add("lxn-overflow-hidden");
      document.documentElement.classList.add("lxn-overflow-hidden");
      document.documentElement.scrollTop = document.body.scrollTop = this.currentScrollTop;
      document.body.classList.remove("lxn-overflow-hidden");
      document.documentElement.classList.remove("lxn-overflow-hidden");
    },
    buttonState: function (index) {
      if(this.dropDownContex.selectedIndex == index){
        return 'selected';
      }else{
        return '';
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .DropDown-main {
    height: 50px;
    background-color: #FFFFFF;
    color: #52626C;
    line-height: 50px;
    padding-left: 14px;
    padding-right: 14px;
  }
  .DropDown-main.disabled {
    opacity: 0.4;
  }
  .DropDown-wrapper-modal {
    min-height: calc(100% + 36px);
    left: 0;
    top: -36px;
    background-color: #FFFFFF;
    z-index: 2;
    margin-bottom: 14px;
  }
  .DropDown-wrapper-icon {
    top: 0;
    left: 0;
    padding: 5px;
  }
  .DropDown-icon {
    width: 40px;
    height: 40px;
  }
  .DropDownModal-wrapper-header {
    height: 50px;
    line-height: 50px;
    background-color: #53636C;
    color: #FFFFFF;
  }
  .DropDownModal-wrapper-options {
    padding: 14px;
  }
  .DropDownModal-option {
    margin-bottom: 14px;
  }
</style>
